<template>
<div class="notifications">
  <div class="ui centered inline loader" :class="{'active': form.waiting}"></div>
  <pagination :pager="pager" :callback="search"></pagination>
  <table class="ui striped table">
    <thead>
      <tr>
        <th>店舗名</th>
        <th>未読通知数</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="shop in shops" :key="shop.id">
        <td>
          <a class="clickable" :href="shop.auth_url" target="_blank">{{ shop.name }}</a>
        </td>
        <td>{{ shop.unread_count }}件</td>
      </tr>
    </tbody>
  </table>
</div>
</template>

<script>
export default {
    data: function() {
        return {
            form: this.createForm(),
            pager: this.createPager(15),
            shops: []
        };
    },
    created: function() {
        this.search(this.pager.current());
    },
    methods: {
        search: function(opt_position) {
            var position = opt_position || this.pager.first();
            this.merge(this.form.model, position);
            this.form.get('/afadmin/api/shops/notifications', function(response) {
                this.shops = response.data;
                this.pager.update(response.data, response);
            });
        }
    }
};
</script>
